import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DynamicResourceService } from '../../services/dynamic-resource.service';

@Component({
  selector: 'app-resource-file-redirect',
  templateUrl: './resource-file-redirect.component.html',
  styleUrls: ['./resource-file-redirect.component.css']
})
export class ResourceFileRedirectComponent implements OnInit {

  constructor(private readonly dynamicResourceService: DynamicResourceService,
              private readonly activatedRoute: ActivatedRoute) { }

  public ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.dynamicResourceService.findById(id, true).subscribe({
        next: (url: string) => {
          window.location.href = url;
        },
        error: (error) => {}
      });
    }
  }
}
